import React from "react";
import { Link, useLocation } from "react-router-dom";

import { OK } from "../constants/statusCode";
import { logoutData } from "../features/auth/logout/logoutSlice";


const SidebarItem = ({ image, link, title, activeLinks, subMenu = [] }) => {
 
  const location = useLocation();

    
    const getUrl = () => {
        let url = '/'.concat(location?.pathname.split('/')[1]);
        return url;
    };

    const isActive = activeLinks?.includes(getUrl());

    return (
      <>
        <ul>
          <li>
            <Link
              to={link}
              title={title}
              className={`nav-link ${isActive ? "active" : ""}`}
            >
              {image ? (
                <img className="nav-link-icn" src={image} alt="noteicn" />
              ) : null}
              <span className="nav-link-txt">{title}</span>
            </Link>
          </li>
          {/* <li>
                    <a href="" className="nav-link">
                        <img className="nav-link-icn" src="images/element_plus.svg" alt="element_plus" />
                        <span className="nav-link-txt">Categories</span>
                    </a>
                </li>
                <li>
                    <a href="" className="nav-link">
                        <img className="nav-link-icn" src="images/status_up.svg" alt="status_up" />
                        <span className="nav-link-txt">Reports</span>
                    </a>
                </li>
                <li>
                    <a href="" className="nav-link">
                        <img className="nav-link-icn" src="images/profile_2user.svg" alt="profile_2user" />
                        <span className="nav-link-txt">User Management</span>
                    </a>
                </li>
                <li>
                    <a href="" className="nav-link">
                        <img className="nav-link-icn" src="images/settings.svg" alt="Settings" />
                        <span className="nav-link-txt">Settings</span>
                    </a>
                </li>
                <li>
                    <a href="" className="nav-link">
                        <img className="nav-link-icn" src="images/noteicn.svg" alt="noteicn" />
                        <span className="nav-link-txt">Notifications</span>
                    </a>
                </li> */}
        </ul>
      </>
    );
}

export default SidebarItem;